import { LoaderActions } from '@store/loaders'
import { ErrorNotification } from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import API from '@/api'
import { InternalTemplatesActions, type TemplatesActions } from '../actions'
import { TemplateDeletedNotification } from './notifications'

export function* deleteTemplate({
  payload: { id },
}: ReturnType<typeof TemplatesActions.delete>) {
  yield put(LoaderActions.set(id))

  try {
    yield call(API.Template.remove, id)

    yield put(InternalTemplatesActions.remove(id))
    yield put(TemplateDeletedNotification)
  } catch (error) {
    console.error('Failed to delete template', error)

    yield put(ErrorNotification('Failed to delete template'))
  } finally {
    yield put(LoaderActions.unset(id))
  }
}
